import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { AppBar } from "@mui/material";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import { MdOutlineStar } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import styles from "./all_course.module.scss";

// Material ui related
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#fff",
  },
}));

const ExamDemoCourseCard = () => {
  return (
    <div className={styles.course_card}>
      <div className={styles.course_image_wrapper}>
        <img src={getAssets("assets/Rectangle.png")} alt="Feature" />
      </div>
      <div className={`${styles.course_status} ${styles.bestseller}`}>
        Bestseller
      </div>
      <h4 className={styles.course_title}>GRE Quant - Overall View</h4>
      <div className={styles.course_instructor_wrapper}>
        <div className={styles.instructor_avatar_wrapper}>
          <div className={styles.instructor_avatar}>
            <img src={getAssets("assets/images/image 9.png")} alt="Avatar" />
          </div>
          <div className={styles.instructor_name}>Kirill Eremenko</div>
        </div>
        <div className={styles.course_review_wrapper}>
          <MdOutlineStar />
          <span>4.5</span>
        </div>
        <div className={styles.course_enrol_wrapper}>
          <FiUsers />
          <span>1200+</span>
        </div>
      </div>

      <div className={styles.course_price}>
        <span className={styles.course_price_regular}>£319.00</span>
        <span className={styles.course_price_deleted}>£519.00</span>
      </div>

      <Link legacyBehavior href="#">
        <a className={`btn btn-secondary btn-full`}>View More</a>
      </Link>
    </div>
  );
};

export const ElearningAllCourse = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <sectiion>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2 className={styles.heading}>All Course</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictum nunc
            donec vulputate ut in sapien nunc, sit. Amet, viverra arcu est,
            imperdiet. Porta sollicitudin tempus odio gravida eget.
          </p>
        </div>

        <div className={styles.tab_wrapper}>
          <div className="uni_campuses ElearningCourseTab ">
            <div className={classes.root}>
              <AppBar position="static" color="default">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="scrollable force tabs example"
                >
                  <Tab label="All Course" {...a11yProps(0)} />
                  <Tab label="GMAT" {...a11yProps(1)} />
                  <Tab label="GRE" {...a11yProps(2)} />
                  <Tab label="IELTS" {...a11yProps(3)} />
                  <Tab label="TOEFL" {...a11yProps(4)} />
                  <Tab label="SAT" {...a11yProps(5)} />
                  <Tab label="PTE" {...a11yProps(5)} />
                </Tabs>
              </AppBar>

              <TabPanel value={value} index={0}>
                <Grid
                  container
                  spacing={{ xs: 1, sm: 2, md: 4 }}
                  alignItems="center"
                >
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <ExamDemoCourseCard />
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={1}>
                Gmat
              </TabPanel>
              <TabPanel value={value} index={2}>
                GRE
              </TabPanel>
              <TabPanel value={value} index={3}>
                IELTS
              </TabPanel>
              <TabPanel value={value} index={4}>
                TOEFL
              </TabPanel>
              <TabPanel value={value} index={5}>
                SAT
              </TabPanel>
              <TabPanel value={value} index={6}>
                PTE
              </TabPanel>
            </div>
          </div>
        </div>
      </div>
    </sectiion>
  );
};

export default ElearningAllCourse;
